// manual-subscription-billing — Manual payment recording schemas (design
// §3.3/§4, spec Capability 4). Mirrors cash-payment-schemas.ts's precedent
// shape. Provider-neutral — NO `stripe*` field names anywhere in this file;
// manual invoices are reconciled entirely OUTSIDE any payment provider.
import { z } from 'zod';
import { SubscriptionStatusSchema } from './plan-schemas.js';
import { SubscriptionInvoiceResponseSchema } from './subscription-schemas.js';
// ── RecordManualSubscriptionPaymentRequest ──────────────────────────────
export const ManualPaymentMethodSchema = z.enum(['check', 'bank_transfer', 'cash', 'other']);
export const RecordManualSubscriptionPaymentRequestSchema = z.object({
    paymentMethod: ManualPaymentMethodSchema,
    paymentReference: z.string().trim().max(200).optional(),
    /** Defaults to "now" at the use-case level when omitted. */
    paidAt: z.string().datetime().optional(),
});
// ── RecordManualSubscriptionPaymentResponse ─────────────────────────────
export const RecordManualSubscriptionPaymentResponseSchema = z.object({
    invoice: SubscriptionInvoiceResponseSchema,
    /** The owning subscription's status AFTER the payment is recorded — e.g.
     *  a `past_due` subscription reactivates to `active` (REQ-4.5). */
    subscriptionStatus: SubscriptionStatusSchema,
});
//# sourceMappingURL=manual-payment-schemas.js.map